export default __webpack_public_path__ + "static/media/smallIntermission1.21e921d7.mp3";